import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { clearSegments, getSegments } from '../../../../actions';

export const SegmentSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetSegments,
  dispatchClearSegment,
  ...rest
}) => {
  useLayoutEffect(() => {
    dispatchGetSegments(DEFAULT_QUERY_GET_ALL);

    return () => dispatchClearSegment();
  }, []);

  return (
    <Select
      isLoading={loading}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

SegmentSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetSegments: PropTypes.func.isRequired,
  dispatchClearSegment: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

SegmentSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por Nombre',
};

const mapStateToProps = ({ RouteUnit }) => ({
  options: RouteUnit.Segment.getIn(['all', 'content', 'content']).map(
    ({ id, sourceLocation, destinationLocation }) => ({
      value: id,
      label: `${sourceLocation.name} - ${destinationLocation.name}`,
    }),
  ),
  loading: RouteUnit.Segment.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetSegments: getSegments,
  dispatchClearSegment: clearSegments,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentSelect);
